import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';

export type BadgeTone = 'neutral' | 'success' | 'info' | 'warning';

const TONE_CLASSES: Record<BadgeTone, string> = {
  neutral: 'bg-[var(--p-surface-200)] text-surface-600',
  success: 'bg-green-100 text-green-700',
  info: 'bg-blue-100 text-blue-700',
  warning: 'bg-orange-100 text-orange-700',
};

/** Pastille de statut : même forme partout, seule la tonalité change. */
@Component({
  selector: 'elcia-badge',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<span [class]="classes()"><ng-content/></span>`,
})
export class ElciaBadge {
  readonly tone = input<BadgeTone>('neutral');

  protected readonly classes = computed(() =>
    `text-xs font-bold rounded-full py-0.5 px-2 whitespace-nowrap ${TONE_CLASSES[this.tone()]}`);
}
